import { render, staticRenderFns } from "./form-render.vue?vue&type=template&id=7378faad&scoped=true"
import script from "./form-render.vue?vue&type=script&lang=js"
export * from "./form-render.vue?vue&type=script&lang=js"
import style0 from "./form-render.vue?vue&type=style&index=0&id=7378faad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7378faad",
  null
  
)

export default component.exports